export class StatusValidationError extends Error {
  public statusValidation?: any

  constructor(message: string, statusValidation?: any) {
    super(message)
    this.statusValidation = statusValidation
  }
}
